import mock from '../mock'

const data = {
  pricing: {
    basicPlan: {
      title: 'Monthly',
      img: require('@src/assets/images/illustration/Pot1.svg').default,
      subtitle: 'Passive Candidates',
      monthlyPrice: 74,
      yearlyPlan: {
        perMonth: 42,
        totalAnnual: 502
      },
      planBenefits: [
        'Effective Resume Keywords',
        'Job Search Engine searches for you',
        'Market Maps, Keyword Graphs and Clouds',
        'Business hours phone support',
        'Email and web support',
        'Upgrade Anytime'
      ],
      popular: false
    },
    standardPlan: {
      title: 'Quarterly',
      img: require('@src/assets/images/illustration/Pot2.svg').default,
      subtitle: 'For Active Job Seekers',
      monthlyPrice: 74,
      yearlyPlan: {
        perMonth: 49,
        totalAnnual: 588
      },
      planBenefits: [
        'Effective Resume Keywords',
        'Job Search Engine searches for you',
        'Market Maps, Keyword Graphs and Clouds',
        '3 months for the price of 2',
        'Business hours phone support',
        'Email and web support',
        'Upgrade Anytime'
      ],
      popular: true
    },
    enterprisePlan: {
      title: 'Enterprise',
      img: require('@src/assets/images/illustration/Pot3.svg').default,
      subtitle: 'Solution for big organizations',
      monthlyPrice: 500,
      yearlyPlan: {
        perMonth: 500,
        totalAnnual: 6000
      },
      planBenefits: [
        'Effective Resume Keywords',
        'Job Search Engine searches for you',
        'Market Maps, Keyword Graphs and Clouds',
        'Premium support',
        '6 months of access to Quuery',
        'Early Access to newest features in Beta'
      ],
      popular: false
    },
    qandA: [
      {
        question: 'Does my subscription automatically renew?',
        ans: 'Pastry pudding cookie toffee bonbon jujubes jujubes powder topping. Jelly beans gummi bears sweet roll bonbon muffin liquorice. Wafer lollipop sesame snaps. Brownie macaroon cookie muffin cupcake candy caramels tiramisu. Oat cake chocolate cake sweet jelly-o brownie biscuit marzipan. Jujubes donut marzipan chocolate bar. Jujubes sugar plum jelly beans tiramisu icing cheesecake.'
      },
      {
        question: 'Can I store the item on an intranet so everyone has access?',
        ans: 'Tiramisu marshmallow dessert halvah bonbon cake gingerbread. Jelly beans chocolate pie powder. Dessert pudding chocolate cake bonbon bear claw cotton candy cheesecake. Biscuit fruitcake macaroon carrot cake. Chocolate cake bear claw muffin chupa chups pudding.'
      },
      {
        question: 'Am I allowed to modify the item that I purchased?',
        ans: 'Tart gummies dragée lollipop fruitcake pastry oat cake. Cookie jelly jelly macaroon icing jelly beans soufflé cake sweet. Macaroon sesame snaps cheesecake tart cake sugar plum. Dessert jelly-o sweet muffin chocolate candy pie tootsie roll marzipan. Carrot cake marshmallow pastry. Bonbon biscuit pastry topping toffee dessert gummies. Topping apple pie pie croissant cotton candy dessert tiramisu.'
      }
    ]
  }
}

mock.onGet('/pricing/data').reply(() => [200, data.pricing])
